import {
  Context,
  useForgotPasswordFactory,
  UseForgotPasswordFactoryParams
} from '@vue-storefront/core';

const factoryParams: UseForgotPasswordFactoryParams<any> = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resetPassword: async (context: Context, { email, customQuery }) => {
    const result = await context.$xbuy.api.EmailCode(customQuery);
    return {code: result.code, data: result.data, message: result.message};
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setNewPassword: async (context: Context, { tokenValue, newPassword, customQuery }) => {
    // console.log('Mocked: setNewPassword');
    const result = await context.$xbuy.api.resetPassword(customQuery);
    return {code: result.code, data: result.data, message: result.message};
  }
};

export const useForgotPassword = useForgotPasswordFactory<any>(factoryParams);
